/* ============================================================
   GABBIANO CUSTOM — Available sizes on product card hover
   ------------------------------------------------------------
   Shows the size run under each product card on hover, with
   sold-out sizes struck through. When the visitor hovers a colour
   swatch, availability is recalculated for that colour.

   Self-contained: reads the product handle from the theme's own
   <product-card handle="..."> element and fetches variant data
   from /products/<handle>.js on hover, then caches it. Nothing
   extra is loaded on page load.
   ============================================================ */
(function () {
  'use strict';

  window.GB_PRODUCT_CACHE = window.GB_PRODUCT_CACHE || {};

  var SIZE_NAMES = ['size', 'sizes', 'maat', 'maten', 'grootte', 'taille', 'größe', 'groesse'];
  var COLOR_NAMES = ['color', 'colour', 'kleur', 'couleur', 'farbe'];

  function getProduct(handle) {
    if (window.GB_PRODUCT_CACHE[handle]) return window.GB_PRODUCT_CACHE[handle];

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    window.GB_PRODUCT_CACHE[handle] = fetch(root + 'products/' + handle + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });

    return window.GB_PRODUCT_CACHE[handle];
  }

  function optionNames(product) {
    if (!product || !product.options) return [];
    return product.options.map(function (option) {
      return String(typeof option === 'string' ? option : option.name || '').toLowerCase().trim();
    });
  }

  function findOption(names, candidates) {
    for (var i = 0; i < names.length; i++) {
      if (candidates.indexOf(names[i]) !== -1) return i;
    }
    return -1;
  }

  function optionValue(variant, index) {
    var values = variant.options || [variant.option1, variant.option2, variant.option3];
    return values[index];
  }

  /* Which colour is the card currently showing? Match the visible image
     against the variant images; fall back to the first variant. */
  function currentColor(card, product, colorIndex) {
    if (colorIndex === -1) return null;

    if (card.dataset.gbColor) return card.dataset.gbColor;

    var image = card.querySelector('.product-card__image--primary');
    var src = image ? (image.getAttribute('src') || image.currentSrc || '') : '';
    var key = src.split('?')[0].split('/').pop().toLowerCase();

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var featured = variant.featured_image && variant.featured_image.src;

      if (featured && key && String(featured).toLowerCase().indexOf(key.split('_')[0]) !== -1) {
        return optionValue(variant, colorIndex);
      }
    }

    return optionValue(product.variants[0], colorIndex);
  }

  function sizeRun(product, color) {
    var names = optionNames(product);
    var sizeIndex = findOption(names, SIZE_NAMES);
    if (sizeIndex === -1) return [];

    var colorIndex = findOption(names, COLOR_NAMES);
    var order = [];
    var state = {};

    product.variants.forEach(function (variant) {
      if (color && colorIndex !== -1 && optionValue(variant, colorIndex) !== color) return;

      var size = optionValue(variant, sizeIndex);
      if (!size) return;

      if (!(size in state)) {
        order.push(size);
        state[size] = false;
      }

      if (variant.available) state[size] = true;
    });

    return order.map(function (size) {
      return { label: size, available: state[size] };
    });
  }

  function render(card, sizes) {
    var info = card.querySelector('.product-card__info');
    if (!info || !sizes.length) return;

    var row = card.querySelector('.product-card__sizes');

    if (!row) {
      row = document.createElement('div');
      row.className = 'product-card__sizes';
      row.setAttribute('aria-hidden', 'true');
      info.appendChild(row);
    }

    row.innerHTML = sizes
      .map(function (size) {
        var className = 'product-card__size' + (size.available ? '' : ' product-card__size--out');
        var text = String(size.label).replace(/[<>&]/g, '');
        return '<span class="' + className + '">' + text + '</span>';
      })
      .join('');
  }

  function paint(card, color) {
    var handle = card.getAttribute('handle');
    if (!handle) return;

    getProduct(handle).then(function (product) {
      if (!product || !product.variants) return;

      var names = optionNames(product);
      var colorIndex = findOption(names, COLOR_NAMES);
      var active = color || currentColor(card, product, colorIndex);

      render(card, sizeRun(product, active));
    });
  }

  /* Load on hover: the data is ready well before the visitor decides */
  document.addEventListener(
    'pointerenter',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var card = target.closest('product-card[handle]');
      if (!card) return;

      /* Hovering a colour swatch: recalculate for that colour */
      var swatch = target.closest('.color-swatch, .block-swatch, .thumbnail-swatch');

      if (swatch) {
        var id = swatch.getAttribute('for');
        var input = id ? document.getElementById(id) : null;
        var variantId = input && input.getAttribute('data-variant-id');

        if (variantId) {
          getProduct(card.getAttribute('handle')).then(function (product) {
            if (!product) return;

            var colorIndex = findOption(optionNames(product), COLOR_NAMES);
            if (colorIndex === -1) return;

            for (var i = 0; i < product.variants.length; i++) {
              if (String(product.variants[i].id) === String(variantId)) {
                var color = optionValue(product.variants[i], colorIndex);
                card.dataset.gbColor = color;
                paint(card, color);
                return;
              }
            }
          });
          return;
        }
      }

      paint(card);
    },
    true
  );
})();
